import gql from "graphql-tag";

export const CREATE_WEBSITE_LEAD_MUTATION = gql`
  mutation createWebsiteLead($websiteLeadInput: WebsiteLeadInput!) {
    createWebsiteLead(websiteLeadInput: $websiteLeadInput) {
      firstName
      surname
      email
      contactNumber
      userAgent
      referrer
    }
  }
`;
